import useBypassVenueFetchForEnterpriseUsersFeatureFlag from './useBypassVenueFetchForEnterpriseUsers';
import { useGetBrandsForUser } from './useGetBrandsForUser';
import { useGetEnterprisesForUser } from './useGetEnterprisesForUser';

const useIsEnterpriseUser = () => {
  const { isLoading: isLoadingFF, isEnabled: isFeatureEnabled } = useBypassVenueFetchForEnterpriseUsersFeatureFlag();

  const { enterprises, isLoading: isLoadingEnterprises } = useGetEnterprisesForUser(isFeatureEnabled);
  const { brands, isLoading: isLoadingBrands } = useGetBrandsForUser(isFeatureEnabled);

  const isLoading = isLoadingFF || (isFeatureEnabled && (isLoadingEnterprises || isLoadingBrands));

  // TODO: replace with backend call
  const isEnterpriseUser = !isLoading && (enterprises.length > 0 || brands.length > 0);
  return { isEnterpriseUser, isLoading };
};

export default useIsEnterpriseUser;
